<app-timeline-progress-bar [steps]="timelineSteps" (clickEvent)="navigate($event)"></app-timeline-progress-bar>
